import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type BirthdaysSortDirection = "asc" | "desc";

/**
 * Redux state interface for Birthdays Action Report.
 *
 * @interface BirthdaysARState
 * @property {BirthdaysSortDirection} sortDirection - Current sort direction for name sorting
 */
interface BirthdaysARState {
  sortDirection: BirthdaysSortDirection;
}

export const initialState: BirthdaysARState = {
  sortDirection: "asc",
};

const { actions, reducer } = createSlice({
  name: "birthdaysActionReport",
  initialState,
  reducers: {
    setSortDirection: (state, action: PayloadAction<BirthdaysSortDirection>) => {
      state.sortDirection = action.payload;
    },
    toggleSortDirection: (state) => {
      state.sortDirection = state.sortDirection === "asc" ? "desc" : "asc";
    },
  },
});

export const { setSortDirection, toggleSortDirection } = actions;

export default reducer;
